import { render, staticRenderFns } from "./ThePart1Main.vue?vue&type=template&id=7a22708a&scoped=true"
import script from "./ThePart1Main.vue?vue&type=script&lang=js"
export * from "./ThePart1Main.vue?vue&type=script&lang=js"
import style0 from "./ThePart1Main.vue?vue&type=style&index=0&id=7a22708a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a22708a",
  null
  
)

export default component.exports